import { useEffect } from "react";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config/useConfig";
import LocalIframe from "../local-iframe/LocalIframe";
import PreviewEmbedProps from "../PreviewEmbedProps";

/**
 * Preview Media Thumbnail Embed in an iframe
 *
 * an iframe is used to load the relevant player lib without interfering
 * with the host page.
 */
export function PreviewThumbEmbed(props: PreviewEmbedProps) {
    const {
        width = 432,
        height = 243,
        title,
        partnerId,
        uiConfId,
        entryId,
        ks,
        serviceUrl,
        cdnUrl = "https://cdnapisec.kaltura.com",
        startTime,
        endTime,
        loadThumbnailWithKs = false,
        onPlay,
    } = props;

    const {
        application: { cspNonce },
    } = useConfig();

    const playerLib = `${cdnUrl}/p/${partnerId}/embedPlaykitJs/uiconf_id/${uiConfId}`;
    const embedLib = `https://static.kaltura.com/content/static/player-scripts/thumbnail-embed.js`;

    const config = {
        targetId: "kaltura_player",
        provider: { partnerId, uiConfId, ks, loadThumbnailWithKs },
        env: { serviceUrl, cdnUrl },
    };
    const mediaInfo = { entryId };

    const script = `__thumbnailEmbed({config: ${JSON.stringify(config)},  mediaInfo: ${JSON.stringify(mediaInfo)}});`;
    const beaconScript = `
        var parentDOM = document.getElementById("kaltura_player");
        parentDOM.addEventListener("click", function(e) {
            if(e.target.className === 'playkit-icon playkit-icon-play' || e.target.className === 'playkit-pre-playback-play-button'){
                parent.postMessage({id: "${uiConfId}"}, '*');
            }
        }, {once: true});
    `;

    const content = `
        <div class="chromatic-ignore">
            <div id="kaltura_player"></div>
            <script src="${playerLib}"></script>
            <script src="${embedLib}"></script>
            <script nonce="${cspNonce}">${script}</script>
            <script nonce="${cspNonce}">${beaconScript}</script>
        </div>`;

    useEffect(() => {
        const handlePlay = (ev: any) => {
            if (ev.data && Number(ev.data.id) === Number(uiConfId)) {
                onPlay?.();
            }
        };
        window.addEventListener("message", handlePlay);
        return () => {
            window.removeEventListener("message", handlePlay);
        };
    }, []);

    return <LocalIframe content={content} title={title} width={width} height={height} />;
}
export default PreviewThumbEmbed;
